/**
 * AdvancedPage — 系统设置「高级 / 危险操作」二级页。
 * 四件套（导出配置 / 重置 Tweaks / 清空操作日志 / 解除 SSO）dev-docs 均无对应端点
 * 或与 P0 约束冲突 → 全部 disabled + title，不假成功（详见 docs/plans §五）。
 */

import { NOT_IN_SCOPE_TITLE, NotInScopeNotice, SectionHead } from './settings-shared';

// ---------- Danger（NOT-in-scope 四件套，§五）----------
export default function AdvancedPage() {
  // 四件套均无后端端点 / 与 P0 约束冲突 → 全部 disabled + title，不假成功
  const ROWS: { name: string; desc: string; btn: string; tone: string; title: string }[] = [
    {
      name: '导出全部运营配置',
      desc: '导出全部 App 的运营配置 (JSON)，用于备份或环境迁移',
      btn: '导出',
      tone: '',
      title: `${NOT_IN_SCOPE_TITLE} · 无配置导出端点`,
    },
    {
      name: '重置 Tweaks 偏好',
      desc: '把界面主题、强调色、密度恢复为默认',
      btn: '重置',
      tone: '',
      title: `${NOT_IN_SCOPE_TITLE} · Tweaks 为本设备外观偏好，重置入口本轮未接`,
    },
    {
      name: '清空操作日志',
      desc: '审计日志为 append-only（P0-admin-audit-log），不可清空',
      btn: '清空',
      tone: 'danger',
      title: '清空与 P0-admin-audit-log「append-only」约束冲突，且无对应端点（§五）',
    },
    {
      name: '解除 SSO 绑定',
      desc: '后台采用邮箱 + 密码 + TOTP 鉴权，无 SSO 绑定',
      btn: '解除',
      tone: 'danger',
      title: `${NOT_IN_SCOPE_TITLE} · 无 SSO 管理端点`,
    },
  ];
  return (
    <>
      <SectionHead title="高级 / 危险操作" />
      <NotInScopeNotice text="以下危险操作 dev-docs 均无对应端点（清空操作日志更与 audit append-only 约束冲突）→ 全部禁用。详见 docs/plans §五。" />
      <div className="card" style={{ padding: 0 }}>
        {ROWS.map((r, i, arr) => (
          <div
            key={r.name}
            className="hstack"
            style={{
              padding: 14,
              gap: 16,
              borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 0,
            }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 500, fontSize: 13 }}>{r.name}</div>
              <div style={{ fontSize: 11.5, color: 'var(--fg-muted)', marginTop: 2 }}>{r.desc}</div>
            </div>
            <button
              className={`btn ${r.tone === 'danger' ? 'btn-danger' : ''}`}
              disabled
              title={r.title}
              style={{ opacity: 0.55, cursor: 'not-allowed' }}
            >
              {r.btn}
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
